<template>
  <div class='box'>
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch :searchList='searchList' v-on:getSearchObj='getSearchObj' />
    </div>
    <div class="listTabel">
      <div class="tabel-total">
        <div class="title-flex">
          <p>{{cardChannelName}}</p>
          <div class="total-num">
            <img src="@/assets/images/card.png" alt="" />
            <span>制卡人：{{makeCardUserNum}}</span>
          </div>
        </div>
        <el-button type="primary" size="small" @click="exportData">导出</el-button>
      </div>
      <BaseTable :data="tableData" :optimize='true' tooltip-effect="dark" :column="tableConfig" pagination
        :auto-scroll="true"  :total="total" :page.sync="searchParams.current" :limit.sync="searchParams.size"
        @pagination="getList">
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { cardRecord, cardExport } from "@/api/cardPwd.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      breadList: [
        { name: "运营管理" },
        { name: "卡密管理" },
        { name: "使用记录" }
      ],
      makeCardUserNum: 0,
      cardChannelName: "",
      searchList: [
        {
          label: "制卡人手机号",
          value: 1,
          paramName: "makeCardPhone",
          inputType: "input"
        },
        {
          label: "兑换状态",
          value: 2,
          paramName: "cardRecordCashState",
          inputType: "select",
          optionData: [
            {
              label: "已核销",
              value: "1"
            },
            {
              label: "未核销",
              value: "0"
            }
          ]
        },
        {
          label: "卡密生成时间",
          showLabel: true,
          paramName: "timeRange", // 必须为timeRange
          inputType: "datetimerange", //时间范围
          isTime: true,
          paramstartTime: "startTime", //xxx 传入后端开始时间字段名称
          paramEndTime: "endTime" //xxxx 传入后端结束时间字段名称
        }
      ],
      searchParams: {
        size: 20,
        current: 1
      },
      tableData: [],
      tableConfig: [
        {
          label: "制卡人手机号",
          align: "center",
          prop: "makeCardPhone"
        },
        {
          label: "制卡人姓名",
          align: "center",
          prop: "makeCardName"
        },
        {
          label: "卡号/卡密",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.cardPass}/{scope.row.cardCode}
              </span>
            );
          }
        },
        {
          label: "区域",
          align: "center",
          prop: "belongArea",
          size: "mini"
        },
        {
          label: "所属产品",
          align: "center",
          prop: "belongProduct",
          size: "mini"
        },
        {
          label: "卡密生成时间",
          align: "center",
          width: 160,
          prop: "cardRecordCreateTime"
        },
        {
          label: "兑换状态",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.cardRecordCashState ? "已核销" : "未核销"}
              </span>
            );
          }
        },
        {
          label: "核销时间",
          align: "center",
          width: 160,
          prop: "cardRecordCashTime"
        },
        {
          label: "用户手机号",
          align: "center",
          prop: "cashUserPhone"
        },
        {
          label: "兑换服务",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.cashServiceType == 1 ? "全病程服务" : "默认"}
              </span>
            );
          }
        } 
      ],
      total: 0
    };
  },
  created() {
    if (this.$route.query.cardId) {
      this.cardId = this.$route.query.cardId;
      this.getList();
    }
  },

  methods: {
    onAddClick(data) {
      this.$copyText(data)
        .then(result => {
          this.$message.success("复制成功");
        })
        .catch(err => {});
    },
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...this.searchParams, ...obj };
      this.getList();
    },
    getList() {
      let params = this.searchParams;
      params.cardId = this.cardId;
      if (params.timeKey) {
        delete params.timeKey;
      }
      if (params.timeRange) {
        delete params.timeRange;
      }
      cardRecord(params)
        .then(res => {
          this.makeCardUserNum = res.data.makeCardUserNum;
          this.cardChannelName = res.data.cardChannelName;
          this.total = res.data.pageVo.total;
          this.tableData = res.data.pageVo.records;
        })
        .catch(err => {});
    },
    //导出excel
    exportData() {
      if (this.tableData.length < 1) {
        this.$message.error("无数据可导出！");
        return;
      }
      let params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.isReset) {
        delete params.isReset;
      }
      let end = Object.keys(params);
      params.cardId = this.cardId;
      // 无搜索条件时导出所有数据
      if (end.length <= 3) {
        params.size = 9999;
      }
      cardExport(params)
        .then(res => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel,charset=UTF-8" //将会被放入到blob中的数组内容的MIME类型
          });
          let objectUrl = URL.createObjectURL(blob); //生成一个url
          this.downloadFile(objectUrl, `${"使用记录"}`);
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //下载文件
    downloadFile(content, filename) {
      let a = document.createElement("a");
      a.href = content;
      a.download = filename;
      a.click();
    }
  }
};
</script>
<style lang="less" scoped>
.tabel-total {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .title-flex {
    display: flex;
    align-items: center;
    p {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
  }
  .total-num {
    img {
      width: 16px;
      margin: 0 8px 0 22px;
      display: inline-block;
      vertical-align: middle;
    }
    font-size: 14px;
    color: #ffaf35;
  }
}
</style>